import { getSeoString } from "@shared/helpers/getSeoString";
import { isProduction, isEEStaging } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const DEV_BASE_URL = isProduction() ? "" : "/emerson";

const emersonRoutes = {
  base: isProduction() || isEEStaging() ? "/" : "/emerson",
  pdp: `${DEV_BASE_URL}/products/detail/:brand/:productName/:productId/:sku`,
  getPDP: (brandName: string, productSlug: string, productId: string, emersonVariantId: string) => {
    const brandString = brandName ? getSeoString(brandName) : "brand";

    return `${DEV_BASE_URL}/products/detail/${brandString}/${productSlug}/${productId}/${emersonVariantId}`;
  },
  brands: `${DEV_BASE_URL}/brands`,
  getBrand: (brandName: string, brandId: string) =>
    `${DEV_BASE_URL}/brand/${getSeoString(brandName) + "-" + brandId}`,
  getCategory: (categoryName: string, categoryId: string) =>
    `${DEV_BASE_URL}/category/${getSeoString(categoryName) + "-" + categoryId}`,
  staticSearchResultsPage: {
    staticBrandPage: `${DEV_BASE_URL}/brand/:brandData`,
    staticCategoryPage: `${DEV_BASE_URL}/category/:categoryData`,
  },
  rso: {
    fullscript: "/user/platform-redirect?target_platform_name=fullscript",
  },
  shop: {
    isNew: `${DEV_BASE_URL}/shop?isNew=true`,
    catalog: `${DEV_BASE_URL}/shop`,
  },
  account: {
    basicInfo: `${DEV_BASE_URL}/account`,
    security: `${DEV_BASE_URL}/account/security`,
    credentials: `${DEV_BASE_URL}/account/credentials`,
    wholesalePolicy: `${DEV_BASE_URL}/account/wholesale-policy`,
    shippingAddresses: `${DEV_BASE_URL}/account/shipping-addresses`,
    patientAddresses: `${DEV_BASE_URL}/account/patient-addresses`,
    paymentInfo: `${DEV_BASE_URL}/account/payment-info`,
    preferences: `${DEV_BASE_URL}/account/preferences`,
    taxExemptionCertification: `${DEV_BASE_URL}/account/tax-exemption-certification`,
  },
  orders: {
    orderHistory: `${DEV_BASE_URL}/account/orders`,
    backorders: `${DEV_BASE_URL}/account/orders/back-orders`,
    reorderProducts: `${DEV_BASE_URL}/account/orders/reorder-products`,
  },
  checkout: {
    review: `${DEV_BASE_URL}/checkout`,
    shipping: `${DEV_BASE_URL}/checkout/shipping`,
    payment: `${DEV_BASE_URL}/checkout/payment`,
  },
  logout: "/logout?scope=emerson-logout",
  login: `${DEV_BASE_URL}/login`,
  welcome: `${DEV_BASE_URL}/welcome`,
  practitionerSignup: `${DEV_BASE_URL}/practitioner-signup`,
  onboarding: `${DEV_BASE_URL}/onboarding`,
  privacyPolicy: `${DEV_BASE_URL}/privacy-policy`,
  termsOfSale: `${DEV_BASE_URL}/terms-of-sale`,
  external: {
    support: "https://help.emersonecologics.com/articles/contact-support/",
    education: {
      protocols: "https://fullscript.com/protocols",
      blog: "https://www.emersonecologics.com/blog/",
      academy: "https://academy.fullscript.com/",
      resources: "https://fullscript.com/practice-resources",
    },
    quality: {
      about: "https://go.emersonecologics.com/quality/",
      eqpPartners: "https://www.emersonecologics.com/quality/eqp-partners",
    },
    helpCenter: "https://help.emersonecologics.com/",
    specials: "https://go.emersonecologics.com/specials/",
  },
  deprecatedClassic: {
    allBrands: "/brands/directory/all",
    search: "/shop/search",
    brandOrTaxonomy: `${DEV_BASE_URL}/shop/:brandOrTaxonomy`,
    pdp: `${DEV_BASE_URL}/products/detail/:brand/:productName/:productId/:sku`,
    orderDetails: `${DEV_BASE_URL}/account/orders/:orderId/date/:createDate`,
    support: `${DEV_BASE_URL}/support`,
    customerService: `${DEV_BASE_URL}/CustomerService`,
  },
} as const;

export { emersonRoutes };
